

import http from '@/services/http'

export const SET_LIST_DCTFWEB = 'setListDctfweb'
export const SET_DCTFWEB = 'setDctfweb'
export const SET_MESSAGE_ALERT = 'setMessage'
export const SET_ATIVIDADE_ATUALIZADA = 'setAtividadeAtualizada'
export const SET_ATIVIDADES_ATUALIZADA = 'setAtividadeSAtualizada'

const actions = {

    async listar_dctfweb(context, value) {
        await http.get(value.rota, {
            params: value.filtros
        })
            .then(response => {
                context.commit(SET_LIST_DCTFWEB, response.data)
            })
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async carregar_dctfweb(context, value) {
        let message = await http.post('dctfweb/' + value.atividade_competencia_id)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async atualizar_dados_planilha(context, value) {
        let message = await http.post('dctfweb/' + value.atividade_competencia_id + '/atualiza')
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_dctfweb(context, value) {
        let message = await http.put('dctfweb/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_ATIVIDADE_ATUALIZADA, message.message.conteudo)
    },
    async update_geral_dctfweb(context, value) {
        let message = await http.put('dctfweb/geral', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_ATIVIDADES_ATUALIZADA, message.message.conteudo)

    },
    async adicionar_empresas(context, value) {
        let message = await http.post('dctfweb/empresas-ausentes/' + value.atividade_competencia_id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_ATIVIDADES_ATUALIZADA, message.message.conteudo)

    },

    set_planila(context, value) {
        context.commit(SET_DCTFWEB, value)

    },
};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },

    [SET_LIST_DCTFWEB](state, value) {
        state.lista_dctfweb = value
    },
    [SET_DCTFWEB](state, value) {
        state.dctfweb_fixa = value
    },

    [SET_ATIVIDADE_ATUALIZADA](state, value) {
        state.lista_dctfweb.data = state.lista_dctfweb.data.map(linhaAtividade => {
          const atividadeAtualizada = value.id == linhaAtividade.id;
          return atividadeAtualizada ? value  : linhaAtividade;
        });
      },
      [SET_ATIVIDADES_ATUALIZADA](state, value) {
        state.lista_dctfweb.data = state.lista_dctfweb.data.map(linhaAtividade => {
          const atividadeAtualizada = value.find(atividade => atividade.id === linhaAtividade.id);
          return atividadeAtualizada || linhaAtividade;
        });
      }
};
const getters = {}

const state = {
    mensagem_alert: [],
    lista_dctfweb: {
        data: [],
        pagination: {
            current_page: 1,
            last_page: 1,
            per_page: 10,
            total: 0
        },
        colunas: [],
        tipo_atividade: {},
    },
    dctfweb_fixa: []
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};


